import Axios from 'axios';
import Qs from 'qs';

export default {

  // 积分日志
  listPage(
    user_id,
    info,
    created_at,
    type,
    page,
    limit
  ) {
    return Axios.get('/community/api/admin/integral-log', {
      params: {
        filter: {
          user_id,
          info
        },
        type,
        created_at,
        page,
        limit,
        sort: {
          id: 'desc'
        }
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 调整积分
  change(
    user_id,
    type,
    score,
    remark
  ) {
    return Axios.post(`/community/api/admin/integrals/update/${user_id}`, {
      type,
      score,
      remark
    });
  }

}